module.exports = __webpack_public_path__ + "static/img/A114.3e2cfb14.jpg";